import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/home/daniel/Proyectos/gcom/frontend/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import "core-js/modules/es7.array.includes";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Vue from 'vue';
import QBtn from "../btn/QBtn.js";
import QIcon from "../icon/QIcon.js";
import FabMixin from "../../mixins/fab.js";
import AttrsMixin from "../../mixins/attrs.js";
import ModelToggleMixin from "../../mixins/model-toggle.js";
import { slot, mergeSlot } from "../../utils/slot.js";
import cache from "../../utils/cache.js";
var directions = ['up', 'right', 'down', 'left'];
var alignValues = ['left', 'center', 'right'];
export default Vue.extend({
  name: 'QFab',
  inheritAttrs: false,
  mixins: [FabMixin, AttrsMixin, ModelToggleMixin],
  provide: function provide() {
    return {
      __qFab: this
    };
  },
  props: {
    icon: String,
    activeIcon: String,
    hideIcon: Boolean,
    hideLabel: {
      default: null
    },
    direction: {
      type: String,
      default: 'right',
      validator: function validator(v) {
        return directions.includes(v);
      }
    },
    persistent: Boolean,
    verticalActionsAlign: {
      type: String,
      default: 'center',
      validator: function validator(v) {
        return alignValues.includes(v);
      }
    }
  },
  data: function data() {
    return {
      showing: this.value === true
    };
  },
  computed: {
    hideOnRouteChange: function hideOnRouteChange() {
      return this.persistent !== true;
    },
    classes: function classes() {
      return "q-fab--align-".concat(this.verticalActionsAlign, " ").concat(this.formClass) + (this.showing === true ? ' q-fab--opened' : '');
    },
    attrs: function attrs() {
      return _objectSpread({
        'aria-expanded': this.showing === true ? 'true' : 'false',
        'aria-haspopup': 'true'
      }, this.qAttrs);
    }
  },
  methods: {
    __onChildClick: function __onChildClick(evt) {
      this.hide(evt);

      if (this.$refs.trigger && this.$refs.trigger.$el) {
        this.$refs.trigger.$el.focus();
      }
    }
  },
  render: function render(h) {
    var child = [];
    this.hideIcon !== true && child.push(h('div', {
      staticClass: 'q-fab__icon-holder'
    }, [h(QIcon, {
      staticClass: 'q-fab__icon absolute-full',
      props: {
        name: this.icon || this.$q.iconSet.fab.icon
      }
    }), h(QIcon, {
      staticClass: 'q-fab__active-icon absolute-full',
      props: {
        name: this.activeIcon || this.$q.iconSet.fab.activeIcon
      }
    })]));
    this.label !== '' && child[this.labelProps.action](h('div', this.labelProps.data, [this.label]));
    return h('div', {
      staticClass: 'q-fab z-fab row inline justify-center',
      class: this.classes,
      on: _objectSpread({}, this.qListeners)
    }, [h(QBtn, {
      ref: 'trigger',
      class: this.formClass,
      props: _objectSpread(_objectSpread({}, this.$props), {}, {
        noWrap: true,
        stack: this.stacked,
        align: void 0,
        icon: void 0,
        label: void 0,
        noCaps: true,
        fab: true
      }),
      attrs: this.attrs,
      on: cache(this, 'tog', {
        click: this.toggle
      })
    }, mergeSlot(child, this, 'tooltip')), h('div', {
      staticClass: 'q-fab__actions flex no-wrap inline',
      class: "q-fab__actions--".concat(this.direction)
    }, slot(this, 'default'))]);
  }
});